import React from 'react'
import PropTypes from 'prop-types'
import styles from './Figure.module.css'
import Img from './Img'

// Portable-text <figure>. The `asset` field is pre-resolved to a ResolvedImage
// descriptor by the server-side content walker (task #67), so this renders the
// canonical <Img> (plain server <img srcSet> + CSS blur-up) and imports nothing
// manifest-backed.
function Figure({ node }) {
  const { alt, caption, asset } = node
  if (!asset || !asset.src) {
    return undefined
  }

  return (
    <figure className={styles.content}>
      <Img
        image={asset}
        className={styles.image}
        alt={alt || asset.alt || ''}
        layout="responsive"
        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 80vw, 1200px"
        objectFit="contain"
      />
      {caption && (
        <figcaption>
          <div className={styles.caption}>
            <div className={styles.captionBox}>
              <p>{caption}</p>
            </div>
          </div>
        </figcaption>
      )}
    </figure>
  )
}

Figure.propTypes = {
  node: PropTypes.shape({
    alt: PropTypes.string,
    caption: PropTypes.string,
    asset: PropTypes.object,
  }),
}
export default Figure
